export enum SettingNamesEnum {
  LayoutTypeSorting = 'LayoutTypeSorting',
  FieldConfig = 'FieldConfig',
  FaultFieldsMemoryValues = "FaultFieldsMemoryValues"
}
